/**
 * Insurance coverage configuration for Gontijo brand (INS-1211).
 *
 * Gontijo's optional "seguro facultativo" is presented as a single opt-in on the passenger
 * (per-seat) — "Sim, desejo incluir o seguro facultativo no valor de R$ 6,00 na passagem"
 * (Aurora, INS-1113). Per product (brugali on INS-1113) Gontijo publishes NO coverage detail
 * on its own site, so there is no coverage list / details modal to show: `coverageItems` is
 * intentionally empty and the disclaimer is blank. Any coverage keys later provided by the API
 * (`insurance.coverages`) still flow through `getInsuranceCoverageByBrand`.
 */
const gontijoInsuranceCoverage = {
  coverageItems: [],
  disclaimerText: '',
};

export default gontijoInsuranceCoverage;
